import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { addAlert } from 'store/actions/alert/alerts';
import { authGetRequest } from 'helpers/apiRequests';
import { fromUnderScoreToUpperCase } from 'helpers/variablesNamesFit';
import AddUsers from './AddUser/AddUser';
import DisplayUsers from './DisplayUsers/DisplayUsers';
import EditUser from './EditUser/EditUser';
import useStyles from './ExistingUsersUseStyles';

const ExistingUsers = () => {
  const classes = useStyles();
  const [users, setUsers] = React.useState([]);
  const [organizations, setOrganizations] = React.useState([]);
  const [userToEdit, setUserToEdit] = React.useState(null);
  const [addNewUserFlag, setAddNewUserFlag] = React.useState(false);
  const dispatch = useDispatch();
  const canSetState = React.useRef(true);
  const useString = () => {
    const language = useSelector(state => state.language);
    return language;
  };

  const alertSubtitles = useString().alerts;

  const apiGetUsers = () => {
    authGetRequest('userList').then(result => {
      if (canSetState.current)
        if (result.status === 200) {
          const parsedData = result.data.map(user =>
            fromUnderScoreToUpperCase(user)
          );
          for (const user of parsedData) {
            const tmp = user.isActive;
            delete user.isActive;
            user.isActive_ = tmp;
          }
          setUsers(parsedData);
        } else
          dispatch(
            addAlert({
              title: alertSubtitles[result.data.code].title_,
              desc: alertSubtitles[result.data.code].desc_,
              type: 'error',
            })
          );
    });
  };

  const apiGetOrganizations = () => {
    authGetRequest('organizations').then(result => {
      if (canSetState.current)
        if (result.status === 200) {
          setOrganizations(result.data);
        } else {
          dispatch(
            addAlert({
              title: alertSubtitles[result.data.code].title_,
              desc: alertSubtitles[result.data.code].desc_,
              type: 'error',
            })
          );
        }
    });
  };

  const cleanUp = () => {
    setOrganizations([]);
    setUsers([]);
    setUserToEdit(null);
    canSetState.current = false;
  };

  React.useEffect(() => {
    apiGetUsers();
    apiGetOrganizations();

    return () => {
      cleanUp();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goBackToMainScreen = () => {
    setAddNewUserFlag(false);
    setUserToEdit(null);
    apiGetUsers();
  };

  return (
    <div className={classes.Users}>
      {!addNewUserFlag && !userToEdit && (
        <DisplayUsers
          users={users}
          organizations={organizations}
          iconEditActionFunction={setUserToEdit}
          setAddNewUserFlag={setAddNewUserFlag}
        />
      )}
      {addNewUserFlag && <AddUsers goBackToMainScreen={goBackToMainScreen} />}

      {!!userToEdit && (
        <EditUser user={userToEdit} goBackToMainScreen={goBackToMainScreen} />
      )}
    </div>
  );
};

export default ExistingUsers;
